var leica = leica || {};
leica.pi = leica.pi || {};
leica.pi.esm = leica.pi.esm || {};

leica.pi.esm.floatingFooter = (function() {
	"use strict";
	var  ff= {};
	// Cache the $(window) reference for use during scroll events.
	var $window = $( window );
	
	ff.run = function($table){
		syncFooter($table);
		stickyFooter($table);
	}
	// clone the footer 
	ff.CloneFooter = function($table){
		$table.find('table.ListFooter').each(function() {
			var $this = $(this);
			
			// Disable the floating footer for case attachements , case report etc in details page. 
			// Similar for specimen attachemnt and specimen TMA core etc in details page  
			// Also disable the floating footer (clone) for the PALModule (Network)
			if($this.closest('.SubSectionRight').attr('class') === 'SubSectionRight' || $this.closest('.PALTabDiv').length === 1){
				return;
			}
			
			var $clonedSection = $this.parent().find('table.ListFooter_clone');
			// Add the clone div only once per section
			if($clonedSection.length === 0){					
				var cloneFooter = $this.clone(true).appendTo($this.parent());
				cloneFooter.removeAttr('origtop');
				
				cloneFooter.attr("class", renameClass(cloneFooter));
				var $RecordCounterMenu = cloneFooter.find('ul');
				var $RecordCounterInput = cloneFooter.find('.RecordCounter input');
				// Remove the source click event and add new click event for cloned block
				cloneFooter.find('.RecordCounter img').off('click').on('click', function(event){ 
					$RecordCounterInput.focus();
				});
				// Rotate down arrow to up arrow
				RotateSvg(cloneFooter.find('.RecordCounter img'), 180);
				
				// Remove the focus and blur event from the source and apply new for cloned
				$RecordCounterInput.off('focus blur').on('focus blur', function(event){ 
					  if (event.type == 'focus'){
					    $RecordCounterMenu.show();
					  } else {
					    $RecordCounterMenu.hide();
					  }
				});
				//Remove the source mousedown event and add new mousedown event for cloned block
				cloneFooter.find('li').off('mousedown').on('mousedown', function(event){ 
					$this = $(this);
					// Hide the ul block
					$this.parent().hide();
					// upate the selected list item to input text
					$RecordCounterInput.val($this.data('value')).trigger('change');					
				});
								
				// Always add this after the '_clone' addition
				cloneFooter.addClass('ListFooter_clone_display');
			} 
		});
	};
	
	// Replace the ListFooter to ListFooter_clone
	function renameClass($elem){
		var $renClass = $elem.attr('class');
		$renClass.split(' ').forEach(function(name, index, arr){			
			if(name == 'ListFooter') {
				arr.splice(index, 1, name+'_clone');
				$renClass = arr.join(' ');				
			}				
		});
		return $renClass;
	}
	
	// Rotate the svg image
	function RotateSvg($this, d) {

	    $this.css({
	          '-moz-transform':'rotate('+d+'deg)',
	          '-webkit-transform':'rotate('+d+'deg)',
	          '-o-transform':'rotate('+d+'deg)',
	          '-ms-transform':'rotate('+d+'deg)',
	          'transform': 'rotate('+d+'deg)'
	     });  
	}
	
	// Sync with source footer
	var syncFooter = function ($table){ 
		
		var $clonedSection = $table.find('table.ListFooter_clone');
		var $origSection = $table.find('table.ListFooter');
		
		if($clonedSection.length !== 0){
			
			// Update paginator cloned input
			$clonedSection.find('.Paginator input').val($origSection.find('.Paginator input').val());
			
			// Update the footer Next button on change of source 
			$clonedSection.find('.Paginator a').filter("[name='Next']").attr('class',$origSection.find('.Paginator a').filter("[name='Next']").attr('class'));
			// Update the footer Previous button on change of source 
			$clonedSection.find('.Paginator a').filter("[name='Previous']").attr('class',$origSection.find('.Paginator a').filter("[name='Previous']").attr('class'));
		
			// Update the cloned block to tackle changes from source to cloned section
			$clonedSection.find('.RecordCounter input').val($origSection.find('.RecordCounter input').val());
		}
	}				
	
	// toggle the footer display with scroll
	var stickyFooter = function($table){		
		var fixedSectionFooter = window._.throttle(function fixedSectionFooterFunction(event){
				
			$table.find('table.ListFooter_clone').each(function() {
				var $this = $(this);
				var $orig_footer = $this.parent().find('table.ListFooter');
				var $orig_footer_height = $orig_footer.height();
				
				$this.find('ul').hide();
				
				var _top = $table.offset().top;
				var winScrollTop = $window.scrollTop();
				var _footTop = $orig_footer.offset().top ;
				var _scrollBottom = $(document).height() - $window.height() - winScrollTop;
				
													
				// Display the floating pagination footer when scroll between floating header and footer
				// Hide the floating footer when scroll reaches 150% of footer height.
				if ( winScrollTop > _top && winScrollTop < _footTop && _scrollBottom > $orig_footer_height*1.5) {
					$this.removeClass('ListFooter_clone_display');
				} else {
					$this.addClass('ListFooter_clone_display');
				}
			});
				
		}); 
		$window.on('load scroll resize', fixedSectionFooter);
	}
		
	return ff;
})();


